var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"qWCqYcf6a2B4CyiWFHBKb"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/cs-frontend-v2";

import * as Sentry from '@sentry/nextjs';
import getConfig from 'next/config';


const { publicRuntimeConfig } = getConfig();
const SENTRY_DSN = publicRuntimeConfig.SENTRY_DSN;
const SENTRY_ENVIRONMENT = publicRuntimeConfig.SENTRY_ENVIRONMENT;

Sentry.init({
  environment: SENTRY_ENVIRONMENT,
  dsn: SENTRY_DSN,
  // Adjust this value in production, or use tracesSampler for greater control
  sampleRate: 1,
  tracesSampleRate: 0.05,
  ignoreErrors: [],

  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
});
